export default "__VITE_ASSET__DLo2sBok__"